<template>
  <form id="payableForm" method="post" :action="action" class="text-left my-4 live-form">
    <div class="row mb-4">
      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Policyholder Name</label>
              <div class="form-control-wrap text-lg">
                {{ placement.policyholder.name ? placement.policyholder.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster</label>
              <div class="form-control-wrap text-lg">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.contact_data ? adjusters.public_adjuster.contact_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster Company</label>
              <div class="form-control-wrap text-lg">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.company_data ? adjusters.public_adjuster.company_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Insurance Company</label>
              <div class="form-control-wrap text-lg">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.name
                    ? adjusters.carrier_adjuster.company_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier Adjuster</label>
              <div class="form-control-wrap text-lg">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.name
                    ? adjusters.carrier_adjuster.contact_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Adjuster Preferences</label>
              <div class="form-control-wrap text-lg">
                {{
                  adjusters.carrier_adjuster &&
                  adjusters.carrier_adjuster.contact_data &&
                  adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    ? adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Personal Negotiated Fees</label>
              <div class="form-control-wrap text-lg">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.negotiated_fees
                    ? adjusters.carrier_adjuster.contact_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 text-sm">
        <div class="form-row mb-4">
          <div class="col">
            <div class="form-group">
              <span class="form-control-wrap font-weight-bold">Rent</span>
              <div v-show="realFloat(budget.pro_rated_rent) > 0" class="form-control-wrap justify-content-between ml-3">
                <div class="row align-items-center">
                  <div class="col-10 col-md-9 d-flex flex-wrap flex-md-nowrap align-items-center">
                    <strong class="text-nowrap pr-2">Pro-rated Rent:</strong>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            v-model="budget.pro_rated_start_date"
                            name="budget[pro_rated_start_date]"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            :disabled="has_completed_initial_payment"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                      <span class="px-2"> - </span>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            v-model="budget.pro_rated_end_date"
                            name="budget[pro_rated_end_date]"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            :disabled="has_completed_initial_payment"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                    </div>
                    <strong class="text-nowrap px-1">({{ calculateDays(budget.pro_rated_start_date, budget.pro_rated_end_date) }})</strong>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-control-wrap form-control-currency">
                      <i class="fas fa-dollar-sign"></i>
                      <v-currency
                        :is-blank="false"
                        type="text"
                        class="form-control text-right"
                        name="budget[pro_rated_rent]"
                        v-model="budget.pro_rated_rent"
                        :disabled="has_completed_initial_payment"
                      ></v-currency>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="realFloat(budget.next_month_rent) > 0" class="form-control-wrap justify-content-between ml-3">
                <div class="row align-items-center">
                  <div class="col-10 col-md-9 d-flex flex-wrap flex-md-nowrap align-items-center">
                    <strong class="text-nowrap pr-2">Next Month Rent:</strong>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            v-model="budget.next_month_start_date"
                            name="budget[next_month_start_date]"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            :disabled="has_completed_initial_payment"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                      <span class="px-2"> - </span>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="form-control-wrap form-datepicker">
                          <v-datepicker
                            type="text"
                            v-model="budget.next_month_end_date"
                            name="budget[next_month_end_date]"
                            autocomplete="off"
                            class="form-control datepicker text-center"
                            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\\d\\d"
                            :disabled="has_completed_initial_payment"
                          >
                          </v-datepicker>
                        </div>
                      </div>
                    </div>
                    <strong class="text-nowrap px-1">({{ calculateDays(budget.next_month_start_date, budget.next_month_end_date) }})</strong>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-control-wrap form-control-currency">
                      <i class="fas fa-dollar-sign"></i>
                      <v-currency
                        :is-blank="false"
                        type="text"
                        class="form-control text-right"
                        name="budget[next_month_rent]"
                        v-model="budget.next_month_rent"
                        :disabled="has_completed_initial_payment"
                      ></v-currency>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="hasFees" class="form-row mb-4">
          <div class="col-12">
            <span class="form-control-wrap font-weight-bold">Fees & Deposits</span>
          </div>
          <div class="col-12">
            <div v-show="feesAndDeposits.cleaning_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease Cleaning Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[cleaning_fee]"
                    v-model="budget.cleaning_fee"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.application_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease App Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[application_fee]"
                    v-model="budget.application_fee"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.pet_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Lease Pet Fee</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[pet_fee]"
                    v-model="budget.pet_fee"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="feesAndDeposits.misc_fee > 0" class="row ml-1 align-items-center justify-content-between">
              <div class="col-auto">
                <strong>Misc Fees</strong>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[misc_fee]"
                    v-model="budget.misc_fee"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="hasDeposits" class="form-row mb-4">
          <div class="col-12">
            <span class="form-control-wrap font-weight-bold">Deposits</span>
          </div>
          <div class="col-12">
            <div v-show="deposits.landlord > 0" class="row ml-1 align-items-start justify-content-between">
              <div class="col-auto">
                <strong>Landlord Security Deposit</strong>
                <p class="m-0 ml-3">
                  Paid out of <mark>{{ getPaidOutof(budget.landlord_paid_out_of) }}</mark>
                </p>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[landlord_deposit]"
                    v-model="budget.landlord_deposit"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
            <div v-show="deposits.pet > 0" class="row ml-1 align-items-start justify-content-between">
              <div class="col-auto">
                <strong>Pet Security Deposit</strong>
                <p class="m-0 ml-3">
                  Paid out of <mark>{{ getPaidOutof(budget.pet_paid_out_of) }}</mark>
                </p>
              </div>
              <div class="col-4">
                <div class="form-control-wrap form-control-currency">
                  <i class="fas fa-dollar-sign"></i>
                  <v-currency
                    :is-blank="false"
                    type="text"
                    class="form-control text-right"
                    name="budget[pet_deposit]"
                    v-model="budget.pet_deposit"
                    :disabled="has_completed_initial_payment"
                  ></v-currency>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <span class="text-sm form-control-wrap font-weight-bold">Make Checks Payable To:</span>
              <div class="form-control-wrap text-lg ml-3">
                {{ budget.first_payment == 1 && budget.first_payable_to ? budget.first_payable_to : budget.payable_to ? budget.payable_to : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" :class="{ 'mb-2': budget.payment_method_id == 3, 'mb-4': budget.payment_method_id != 3 }">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Payment Method:</label>
              <div class="form-control-wrap text-lg ml-3">
                {{ payment_method }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="budget.payment_method_id == 3" class="form-row mb-4 ml-4">
          <div class="col">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][penny_test_confirmed]"
                v-model="budget.initial_payment_checklist.penny_test_confirmed"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">Penny Test Confirmed</span>
            </label>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Documents Required:</label>
            </div>
          </div>
        </div>

        <div class="form-row mb-4 ml-4">
          <div class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][property_lease]"
                v-model="budget.initial_payment_checklist.property_lease"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">Property Lease</span>
            </label>
          </div>
          <div class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][w9_completed]"
                v-model="budget.initial_payment_checklist.w9_completed"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">W9 is completed and correct</span>
            </label>
          </div>
          <div class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][tps_housing_agreement]"
                v-model="budget.initial_payment_checklist.tps_housing_agreement"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">TPS Housing Agreement</span>
            </label>
          </div>
          <div class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][tps_auth_to_pay]"
                v-model="budget.initial_payment_checklist.tps_auth_to_pay"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">TPS Authorization to Pay</span>
            </label>
          </div>
          <div class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][carrier_budget_approval]"
                v-model="budget.initial_payment_checklist.carrier_budget_approval"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">Carrier Budget Approval</span>
            </label>
          </div>
          <div v-if="adjusters.public_adjuster && adjusters.public_adjuster.contact_id" class="col-12 mb-1">
            <label class="tps-checkbox">
              <input
                type="checkbox"
                class="required_checkbox"
                name="budget[initial_payment_checklist][pa_omit]"
                v-model="budget.initial_payment_checklist.pa_omit"
                :disabled="has_completed_initial_payment"
              />
              <span class="checkmark"></span>
              <span class="label">PA Omit</span>
            </label>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">A/P Notes:</label>
              <div class="form-control-wrap">
                <textarea
                  spellcheck="true"
                  name="budget[payable_notes]"
                  rows="6"
                  class="form-control alphanumeric-field ruled-textarea"
                  v-model="budget.payable_notes"
                  :disabled="has_completed_initial_payment"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <p class="border-bottom">
          <strong>Move In Total:</strong>
          <span class="float-right">${{ formatMoney(totalAmount) }}</span>
        </p>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["placement", "adjusters", "budget", "property", "hotel", "has_completed_initial_payment"],
  data() {
    return {};
  },
  watch: {
    "budget.pro_rated_start_date"() {
      this.calculateProrationAmount(this.budget.pro_rated_start_date, this.budget.pro_rated_end_date, this.budget, "pro_rated_rent");
    },
    "budget.pro_rated_end_date"() {
      this.calculateProrationAmount(this.budget.pro_rated_start_date, this.budget.pro_rated_end_date, this.budget, "pro_rated_rent");
    },
    "budget.next_month_start_date"() {
      this.calculateProrationAmount(this.budget.next_month_start_date, this.budget.next_month_end_date, this.budget, "next_month_rent");
    },
    "budget.next_month_end_date"() {
      this.calculateProrationAmount(this.budget.next_month_start_date, this.budget.next_month_end_date, this.budget, "next_month_rent");
    }
  },
  methods: {
    calculateDays(start_date, end_date) {
      try {
        const start = moment(start_date, "MM/DD/YYYY");
        const end = moment(end_date, "MM/DD/YYYY");
        const days = end.diff(start, "days") + 1;
        return isNaN(days) ? "0 days" : days + (days === 1 ? " day" : " days");
      } catch (error) {
        return "0 days";
      }
    },
    calculateProrationAmount(start_date, end_date, item = null, key = null) {
      const periods = window.findPeriods(start_date, end_date);
      const amount = this.calculateRentAmount(periods);
      const rentAmount = this.formatMoney(amount, true);

      if (!item) return rentAmount;

      item[key] = rentAmount;
    },
    calculateRentAmount(periods) {
      let amount = 0;

      periods.forEach(period => {
        let diffDays = window.diffDays(period.start_date, period.end_date, this.isCorporate);
        amount += (this.unfurnishedRent / 30) * diffDays;
      });

      return amount;
    },
    realFloat(val) {
      return window.realFloat(val);
    },
    formatMoney(amount) {
      return window.formatMoney(amount);
    },
    getPaidOutof(id) {
      const paidOutof = app.options.paid_out_of.find(opt => opt.id == id);
      return paidOutof ? paidOutof.text : "-";
    }
  },
  computed: {
    action() {
      return `/api/payable_action?property_id=${this.budget.id}`;
    },
    isCorporate() {
      return this.property && this.property.lease_detail && this.property.lease_detail.lease_rate_type === "Daily";
    },
    housing_fee_type() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const housing_fee_type = app.options.housing_fee_types.find(i => i.id == this.adjusters.carrier_adjuster.company_data.housing_fee_type_id);
        return housing_fee_type ? housing_fee_type.text : "-";
      }

      return "-";
    },
    pays_directly() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_directly = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_directly);
        return pays_directly ? pays_directly.text : "-";
      }

      return "-";
    },
    pays_electronically() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_electronically = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_electronically);
        return pays_electronically ? pays_electronically.text : "-";
      }

      return "-";
    },
    payment_method() {
      const payment_method = app.options.payment_methods.find(i => i.id == this.budget.payment_method_id);
      return payment_method ? payment_method.text : "-";
    },
    feesAndDeposits() {
      const feesAndDeposits = {
        cleaning_fee: this.budget.cleaning_fee_first_payment ? this.realFloat(this.budget.cleaning_fee) : 0,
        application_fee: this.budget.application_fee_first_payment ? this.realFloat(this.budget.application_fee) : 0,
        pet_fee: this.budget.pet_fee_first_payment ? this.realFloat(this.budget.pet_fee) : 0,
        misc_fee: this.budget.misc_fee_first_payment ? this.realFloat(this.budget.misc_fee) : 0,
      };

      return feesAndDeposits;
    },
    hasFees() {
      const keys = Object.keys(this.feesAndDeposits);
      return keys.some(key => this.feesAndDeposits[key] > 0);
    },
    deposits() {
      return {
        landlord: this.budget.landlord_deposit_first_payment ? this.realFloat(this.budget.landlord_deposit) : 0,
        pet: this.budget.pet_deposit_first_payment ? this.realFloat(this.budget.pet_deposit) : 0,
      };
    },
    hasDeposits() {
      return this.deposits.landlord || this.deposits.pet;
    },
    itemsTotal() {
      let total = 0;

      let keys = [
        "pro_rated_rent",
        "next_month_rent",
        "cleaning_fee",
        "pet_fee",
        "application_fee",
        "misc_fee",
        "landlord_deposit",
        "pet_deposit",
      ];

      for (let key of keys) {
        switch (key) {
          case "cleaning_fee":
          case "pet_fee":
          case "application_fee":
          case "misc_fee":
            if (this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "landlord_deposit":
            if (this.budget.landlord_paidby_id != 1 && this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "pet_deposit":
            if (this.budget.pet_paidby_id != 1 && this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          default:
            total += this.realFloat(this.budget[key]);
            break;
        }
      }

      return total;
    },
    unfurnishedRent() {
      return this.realFloat(this.budget.unfurnished_rent);
    },
    totalAmount() {
      return this.realFloat(this.itemsTotal);
    }
  }
};
</script>

<style>
.swal2-content {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/payable-request.vue